import { InputHTMLAttributes } from 'react';
import { cn } from './lib';
import './Checkbox.css';

type CheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
};

export function Checkbox({ label, className, ...rest }: CheckboxProps) {
  return (
    <input
      type="checkbox"
      aria-label={label}
      className={cn('mrd-checkbox', className)}
      {...rest}
    />
  );
}
